import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chat-list-item" }
const _hoisted_2 = { class: "item-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "text-content" }
const _hoisted_5 = { class: "p-chat-description" }
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "chat-dropdown-menu"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        alt: "avatar",
        class: "avatar",
        src: _ctx.GetImageUrl()
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, _toDisplayString(_ctx.localChat.Name), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.localChat.Details.Description), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        class: "menu-button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
      }, [
        _createElementVNode("img", { src: _ctx.menuBarIcon }, null, 8, _hoisted_7)
      ]),
      (_ctx.showMenu)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editItem && _ctx.editItem(...args)))
              }, _toDisplayString(_ctx.$t("Button.Edit")), 1),
              _createElementVNode("li", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteItem && _ctx.deleteItem(...args)))
              }, _toDisplayString(_ctx.$t("Button.Delete")), 1)
            ])
          ])), [
            [_directive_click_outside, _ctx.toggleMenu]
          ])
        : _createCommentVNode("", true)
    ])
  ]))
}